module.exports = __webpack_public_path__ + "img/粉色翼龙公仔.16752610.jpg";